import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import paths from 'routes/paths';
import Section from 'components/common/Section';
import { useNavigate, useParams } from 'react-router-dom';
import ContactInfo from './ContactInfo';
import ButtonGroup from './ButtonGroup';
import Footer from './Footer';
import WelcomeStart from './WelcomeStart';
import WelcomeConfirmed from './WelcomeConfirmed';
import WelcomeEdit from './WelcomeEdit';
import { endpointOwlApc } from './customers/endpoint.ts';
import { useOwlApcContext } from './OwlApcProvider';
import Loading from './Loading';
import ErrorSave from './ErrorSave';
import Cookies from 'universal-cookie';

// TODO: move all this saved data to a context/provider
const Welcome = () => {
  const { id, type = 'h', skey } = useParams();
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);
  const [editing, setEditing] = useState(false);
  const [address, setAddress] = useState(null);
  const [textOK, setTextOK] = useState(true);
  const [savedWelcome, setSavedWelcome] = useState(null);
  const [saving, setSaving] = useState(false);
  const [agent, setAgent] = useState(null);
  const [hours, setHours] = useState(null);
  const [error, setError] = useState(false);

  const { welcomeHandler } = useOwlApcContext();

  const cookies = new Cookies(null, { path: '/' });
  cookies.set('testCookie', 'Waiting for completion', {
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7)
  }); // expires in 7 days
  console.log(cookies.get('testCookie')); // Waiting for completion

  async function fetchAddress() {
    const response = await fetch(`${endpointOwlApc}/job/${id}/${skey}`);
    const data = await response.json();
    console.log(data);
    if (!data || !data.address) {
      navigate('/');
      return;
    }
    setAddress(data.address);
    if (data.customerAnswered01welcome)
      setSavedWelcome(data.customerAnswered01welcome);

    if (data.agent) setAgent(data.agent);
    if (data.hours) setHours(data.hours);
  }

  useEffect(() => {
    if (!type || !skey) {
      navigate('/');
      return;
    }
    console.log('Welcome useEffect', { id, type, skey });
    if (id) {
      fetchAddress();
    } else {
      navigate('/');
      return;
    }
  }, [id, type, skey]);

  function getMessage() {
    if (editing) {
      return (
        <WelcomeEdit
          address={address}
          setAddress={setAddress}
          textOK={textOK}
          setTextOK={setTextOK}
          setEditing={setEditing}
          setConfirmed={setConfirmed}
          setSaving={setSaving}
          id={id}
          skey={skey}
        />
      );
    }
    if (saving) {
      return <Loading msg="Saving your response ..." />;
    }
    if (confirmed || savedWelcome) {
      return (
        <>
          <WelcomeConfirmed agent={agent} hours={hours} />
          <ContactInfo address={address} textOK={textOK} />
        </>
      );
    }
    return (
      <>
        {error && <ErrorSave />}
        <WelcomeStart />
        <ContactInfo address={address} textOK={textOK} />
      </>
    );
  }

  function getButtons() {
    if (editing) {
      return null;
    }
    if (!confirmed) {
      return (
        <ButtonGroup
          disabled={!address}
          primaryFunc={
            !savedWelcome &&
            (async () => {
              setSaving(true);
              const result = await welcomeHandler(null, { id, skey });
              setSaving(false);
              if (result) {
                setConfirmed(true);
              } else {
                setError(true);
              }
            })
          }
          primaryText={!savedWelcome && 'This is Correct'}
          secondaryFunc={() => {
            setEditing(true);
          }}
          secondaryText="Make Changes"
        />
      );
    }
    return null;
  }

  return (
    <>
      <Section className="py-3" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Row className="flex-center p-0">
          <Col sm={10} lg={7} className="col-xxl-5">
            <Card>
              <Card.Body className="overflow-hidden p-lg-6">
                <Row className="align-items-center justify-content-between">
                  <Col lg={12}>{getMessage()}</Col>
                </Row>
                {getButtons()}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Section>
      <Footer />
    </>
  );
};

export default Welcome;
